import React, { useState, useEffect } from 'react'
import { onlyNumberWithDecimal } from '../../components/functions'
import CurrencyInput from '../../components/CurrencyInput'
import { Link } from 'react-router-dom'
import Table from 'react-bootstrap/Table'

import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import api from '../api';

import moment from 'moment'
import { useTabelaGestao } from '../../context/GestaoPendenciasContext'

import { useEnergiaCombustivelContext } from '../../context/energiaCombustivelContext'



import { useEnunciadoContext } from '../../context/enunciadoContext'
import { useVerificaDesafioContext } from '../../context/verificaDesafioContext'
import { useSecaoEnunciadoContext } from '../../context/secaoEnunciadoContext'


import StatusValidacaoSecao from '../StatusValidacaoSecao'


const Combustiveis = (props) => {


    const { atualizacaoGestao, setAtualizacaoGestao } = useTabelaGestao()

    var ano = props.ano
    var energia_id = props.energia_id


    const { setEnergiaCombustivel_id } = useEnergiaCombustivelContext()

    const [resultadoCombustivel, setResultadoCombustivel] = useState()




    function consultaCombustiveis() {

        api.get(`energiaCombustivelListaTodos/${energia_id}`).then((result) => {

            

            setResultadoCombustivel(result.data.map((rs) => 

                <tr style={{ cursor: 'pointer'}} onClick={() => {window.$('#modalEnergiaCombustivel').modal('show');setEnergiaCombustivel_id(rs.energiaCombustivel_id)}}>
                    <td>
                        {rs.combustivel}
                    </td>
                    <td>
                        {rs.identificacao}
                    </td>
                    <td>
                        {rs.unidade}
                    </td>
                </tr>

            ))


        }).catch((err) => {

            console.log(err.response)

        })

    }






    useEffect(() => {


        consultaCombustiveis()


    }, [ano, energia_id, atualizacaoGestao])





    var { enunciado, setEnunciado } = useEnunciadoContext()
    var { setSecaoEnunciado } = useSecaoEnunciadoContext()
    var { verificaDesafio } = useVerificaDesafioContext()



    const [totalPendencias, setTotalPendencias] = useState(0)

    const [questao, setQuestao] = useState()



    useEffect(() => {

        verificaValidacoes()

    }, [energia_id, verificaDesafio])


    const verificaValidacoes = () => {

        //console.log('verificado')

        setQuestao()
        

        if (energia_id) {

            var dataPost = {

                formulario_id: energia_id,
                desafio: 'Energia',

            }

            api.post('desafioValidaVarios', dataPost).then((result) => {

                
                var data = result.data
                //console.log(data)
                var totalErros = 0

                for (var k = 0; k < data.length; k++) {

                    if (data[k].status == 'Erro') {


                        switch (data[k].enunciado) {

                            case 'Combustíveis':

                                totalErros = totalErros + 1
                                setQuestao('red')
    
                            break

                            
                        }

                    }

                }

                setTotalPendencias(totalErros)

            }).catch((err) => {

                console.log(err.response)

            })

        }


    }


    


    return (
        <div>


            <div className="col-md-12">
                <div align="left">

                    <Link to='#' style={{ color: questao }} onClick={() => {setEnunciado('Combustíveis');setSecaoEnunciado('Combustíveis');window.$('#modalValidacao').modal('show')}}>
                    [Informar Não Conformidade]</Link>
                    <br/><br/>
                    
                    <button type="button" className="btn btn-primary" onClick={() => {window.$('#modalEnergiaCombustivel').modal('show');setEnergiaCombustivel_id()}}  >+ Adicionar</button>&nbsp;
                    <button type="button" className="btn btn-info" onClick={() => window.$('#modalEnergiaCombustivelResumo').modal('show')}  >Resumo</button>

                    <br/><br/>
                

                </div>
            </div>


            <div className="col-md-12">


                <Table striped bordered hover>

                    <thead>
                        
                        <tr>
                            <th style={{backgroundColor: '#e6f7ec'}}>

                                Combustível

                            </th>
                            <th style={{backgroundColor: '#e6f7ec'}}>

                                Identificação

                            </th>
                            <th style={{backgroundColor: '#e6f7ec'}}>

                                Unidade

                            </th>
                           

                        </tr>
                    </thead>
                    <tbody>
                        {resultadoCombustivel}
                    </tbody>

                </Table>
                

            </div>



            <StatusValidacaoSecao desafio="Energia" secaoCampo="secaoCombustiveis" totalPendencias={totalPendencias} nomeDesafio="Desafio Energia" formulario_id={energia_id} secao="Combustiveis" ano={ano} />



        </div>
    )


}

export default Combustiveis